import { FC } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import TableData from "../../../../../../../components/common/table/TableData";
import { CarbonSnapResultsResponse } from "../../../../../../../datasources/carbonsnap/io/response";

interface Props {
	countryDetails: CarbonSnapResultsResponse["countryDetails"];
}

const CountryTab: FC<Props> = ({ countryDetails }) => {
	const { t } = useTranslation("whatIf.carbonsnap");

	const getColumns = (): GridColDef[] => [
		{
			field: "countryCode",
			headerName: t("results/details/country/code"),
			width: 150,
		},
		{
			field: "countryName",
			headerName: t("results/details/country/name"),
			flex: 1,
		},
		{
			field: "emissions",
			headerName: t("results/details/country/emissions"),
			width: 200,
			align: "right",
			headerAlign: "right",
			renderCell: (params) => `${params.row.emissionsValue.toFixed(2)} ${params.row.emissionsMeasure}`,
		},
	];

	const rows = countryDetails.map((country, index) => ({
		id: country.countryCode || `country-${index}`,
		countryCode: country.countryCode,
		countryName: country.countryName,
		emissionsValue: country.emissions.value,
		emissionsMeasure: country.emissions.measure,
	}));

	return <TableData columns={getColumns()} rows={rows} isLoading={false} onReload={() => {}} />;
};

export default CountryTab;
